/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Menu_CloseInputs */

const en_control_menu_close = /** @type {(inputs: Control_Menu_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close menu`)
};

const zh_control_menu_close = /** @type {(inputs: Control_Menu_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭菜单`)
};

/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Control_Menu_CloseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_menu_close = /** @type {((inputs?: Control_Menu_CloseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Menu_CloseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_menu_close(inputs)
	return zh_control_menu_close(inputs)
});
export { control_menu_close as "control.menu.close" }